import { useQuery } from '@tanstack/react-query'
import { lcLessonPhotosApi } from '@/api/lcLessonPhotos'
export const lessonPhotoKey = (learnerId: number, lessonId: number, attemptId: number | null, componentKey: string | null = null) =>
  ['coaching', 'learner', learnerId, 'lesson', lessonId, 'photos', attemptId ?? 'progress', componentKey] as const
export function useLessonPhotos(learnerId: number, lessonId: number, attemptId: number | null, enabled = true, componentKey: string | null = null) {
  return useQuery({ queryKey: lessonPhotoKey(learnerId, lessonId, attemptId, componentKey), queryFn: () => componentKey == null
    ? lcLessonPhotosApi.list(learnerId, lessonId, attemptId)
    : lcLessonPhotosApi.list(learnerId, lessonId, attemptId, componentKey),
    enabled, staleTime: 30_000, refetchOnWindowFocus: 'always', refetchInterval: false })
}
